<template>
  <div>
    <!-- 国际运费 -->
    <!-- 选中各箱国际运费参考 -->
    <el-dialog :title="$t('message.selectEachBoxForInternationalFreightReference')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="1750px" center>
      <div class="content">
        <h6>
          <!-- 配送单总箱数 -->
          <span>{{ $t("message.totalNumberOfBoxesDelivered") }} :
            {{ boxTotalNum }}</span>
          <!-- 当前选中箱数 -->
          <span>{{ $t("message.numberOfBoxesCurrentlySelected") }} :
            {{ boxIds.length }}</span>
          <!--复制  -->
          <el-button type="primary" @click="copyFreight">{{ $t('message.copy') }}</el-button>
        </h6>
        <el-table :data="tableData" border :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%"
          :header-cell-class-name="addClass" max-height="600" @selection-change="handleSelectionChange">
          <el-table-column label="NO" align="center" type="index"></el-table-column>
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <!-- 发送方式 -->
          <el-table-column property="logistics_name" :label="$t('message.wayToSend')" align="center"></el-table-column>
          <!-- 计费规则 -->
          <el-table-column :label="$t('message.accountingRules')" align="center" width="200">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  计价方式：{{ scope.row.rulePart.chargeFinal == 2 ? "单配送单最终计费" : "单箱计费后累加" }}
                </p>
                <p>
                  计价类型：{{ scope.row.rulePart.chargeMethod == "weight" ? "重量" : "体积" }}
                </p>
                <p>
                  计抛方式：{{ scope.row.rulePart.chargeWhole == "single" ? "单箱" : "整票" }}
                </p>
                <p>抛重比例：{{ scope.row.rulePart.rate }}</p>
              </div>
            </template>
          </el-table-column>
          <!-- 箱数 -->
          <el-table-column property="boxCount" :label="$t('message.boxNum')" align="center"></el-table-column>
          <!-- 合计体积.m³ -->
          <el-table-column property="volume" :label="$t('message.totalVolume') + '.m³'"
            align="center"></el-table-column>
          <!-- 合计实重.kg -->
          <el-table-column property="weight" :label="$t('message.totalRealWeight') + '.kg'"
            align="center"></el-table-column>
          <!-- 计费重量.kg -->
          <el-table-column property="charged_weight" :label="$t('message.BillingWeight')"
            align="center"></el-table-column>
          <!-- 合计抛重.kg -->
          <el-table-column property="volumeWeight" :label="$t('message.totalWeightPao') + '.kg'"
            align="center"></el-table-column>
          <!-- 计费数据 -->
          <el-table-column :label="$t('message.billingData')" align="center" width="200">
            <template slot-scope="scope">
              <div class="template">
                <p>
                  重量体积运费:
                  {{ scope.row.money_detail.weight_volume_money_rmb }}
                </p>
                <p>
                  每箱附加费: {{ scope.row.money_detail.every_box_other_rmb }}
                </p>
                <p>
                  整单附加费:
                  {{ scope.row.money_detail.whole_logistics_other_rmb }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 国际运费.元 -->
          <el-table-column property="total_money_rmb" :label="$t('message.internationalFreight') + '.元'"
            align="center"></el-table-column>
          <!-- 国际运费. -->
          <el-table-column property="total_money_jp" :label="$t('message.internationalFreight') + '.円'"
            align="center"></el-table-column>
          <!--大型荷物の追加費用 -->
          <el-table-column property="total_money_rmb" :label="'大型荷物の追加費用'" align="center">
            <template slot-scope="scope">
              {{ scope.row.extra_money != false ? scope.row.extra_money[0].extra_fee_rmb : '' }}
            </template>
          </el-table-column>
          <!-- 離島配送の追加費用-->
          <el-table-column property="total_money_jp" :label="'離島配送の追加費用'" align="center">
            <template slot-scope="scope">
              {{ scope.row.extra_money != false ? scope.row.extra_money[1].extra_fee_rmb : '' }}
            </template>
          </el-table-column>
          <!-- 电池-->
          <el-table-column :label="'電池付き荷物の追加費用'" align="center">
            <template slot-scope="scope">
              {{ scope.row.extra_money != false ? scope.row.extra_money[2].extra_fee_rmb : '' }}
            </template>
          </el-table-column>
          <!-- 进仓费-->
          <el-table-column :label="'倉庫納品の送料差額'" align="center">
            <template slot-scope="scope">
              {{ scope.row.extra_money != false ? scope.row.extra_money[3].extra_fee_rmb : '' }}
            </template>
          </el-table-column>
          <!-- 通关手续费-->
          <el-table-column :label="'通关手续费'" align="center">
            <template slot-scope="scope">
              {{ scope.row.service_fee_jpy }}
            </template>
          </el-table-column>
          <!-- 选择发货方式-->
          <el-table-column :label="'选择发货方式'" align="center" v-if="status == 22">
            <template slot-scope="scope">
              <el-button type="primary" @click="updateFreightLogistics(scope.row)">选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      weight: "",
      porder_sn: this.$route.query.porder_sn,
      dialogVisible: false,
      boxTotalNum: 0,
      tableData: [],
      multipleSelection: [],
      boxNumList: [],//箱号
      logistics_id: '',
    };
  },
  computed: {
    ...mapState({
      boxIds: (state) => state.porderDetail.boxIds,
      boxList: (state) => state.porderDetail.boxList,
      rate: (state) => state.porderDetail.detail.exchange_rate || 0,
      detail: (state) => state.porderDetail.detail,
      status: (state) => state.porderDetail.status,
    }),
  },
  methods: {
    addClass({ row, rowIndex, column, columnIndex }) {
      if (columnIndex > 10 && columnIndex < 17) {
        return "redText";
      } else {
        return 'whiteText'
      }
    },

    predictLogisticsPrice() {
      // console.log(this.rate);
      let datas = {
        datetime: "",
        list: [],
      };
      this.boxTotalNum = 0;
      this.boxNumList = []
      this.multipleSelection = []
      this.boxList.forEach((item) => {
        item.group.forEach((items) => {
          items.checked = items.list.every((box) => box.checked);
          this.boxTotalNum += items.list.length;
          items.list.forEach((box) => {
            if (box.checked) {
              datas.list.push({
                weight: box.weight,
                volume: box.height * box.width * box.length,
                height: box.height,
                width: box.width,
                length: box.length,
                freight_id: box.id
              });
              this.boxNumList.push(box.number)
            }
          });
        });
      });
      this.$api.porderApi.predictLogisticsPrice(datas).then((res) => {
        res.data.forEach(item => {
          item.total_money_jp = (item.total_money_rmb * this.rate).toFixed(0)
          item.extra_fee_rmb = item.extra_money[2].extra_fee_rmb
        })
        this.tableData = res.data;
        console.log(res);
      });
    },
    // 复制运费
    copyFreight() {
      if (this.multipleSelection == false) return this.$message.error($t('message.selectableOperationalList'))
      let val = `${this.porder_sn}\n${this.boxIds.length}箱\n`

      this.multipleSelection.forEach(item => {
        var otherExpenses = ``
        if (item.extra_money != false) {
          if (item.extra_money[0].extra_fee_rmb) {
            otherExpenses += `(大型荷物の追加費用:${(item.extra_money[0].extra_fee_rmb * this.rate).toFixed(0)}円)`
          }
          if (item.extra_money[1].extra_fee_rmb) {
            otherExpenses += `(離島配送の追加費用:${(item.extra_money[1].extra_fee_rmb * this.rate).toFixed()}円)`
          }
          if (item.extra_money[2].extra_fee_rmb) {
            otherExpenses += `(電池付き荷物の追加費用:${(item.extra_money[2].extra_fee_rmb * this.rate).toFixed(0)}円)`
          }
          if (item.extra_money[3].extra_fee_rmb) {
            otherExpenses += `(倉庫納品の送料差額:${(item.extra_money[3].extra_fee_rmb * this.rate).toFixed(0)}円)`
          }
        }
        val += `${item.logistics_name}: ${item.total_money_jp}円  ${otherExpenses}  ${item.sign_receive_days} \n`
      })
      this.copy(val)

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 批量修改箱子的发送方式
    updateFreightLogistics(row) {
      this.logistics_id = row.logistics_id
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      let max160 = this.isMax160();
      let max30 = this.isMax30();
      if (max30) {
        return this.$alert(`EMS单箱实际重量不能超过30KG`, "提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          center: true,
          callback: (action) => { },
        });
      }
      if (max160) {
        this.$alert(`有箱子三边和超过160cm，请注意！`, "物流提示", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          center: true,
          callback: (action) => {
            if (action == "confirm") {
              // 新物流，海源TK船便，配送单报价时，给箱子选择该物流方式，选海源TK船便的时候
              if (this.logistics_id == 22) {
                this.$alert(
                  `<p style="color:red;font-size:20px">海源TK船便物流只能发关东地区及亚马逊仓库地址，楽天仓库地址，其他地址请与物流确认是否能发，关东地区包含茨城県、栃木県、群馬県、埼玉県、千葉県、東京都、神奈川県，山梨）</p>`,
                  "提示",
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: "确定",
                    center: true,
                    callback: (actions) => {
                      if (actions == "confirm") {
                        this.batchUpdateFreightLogistics();
                      }
                    },
                  }
                );
              } else {
                this.batchUpdateFreightLogistics();
              }
            }
          },
        });
      } else {
        // 新物流，海源TK船便，配送单报价时，给箱子选择该物流方式，选海源TK船便的时候
        if (this.logistics_id == 22) {
          this.$alert(
            `<p style="color:red;font-size:20px">海源TK船便物流只能发关东地区及亚马逊仓库地址，楽天仓库地址，其他地址请与物流确认是否能发，关东地区包含茨城県、栃木県、群馬県、埼玉県、千葉県、東京都、神奈川県，山梨）</p>`,
            "提示",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              center: true,
              callback: (actions) => {
                if (actions == "confirm") {
                  this.batchUpdateFreightLogistics();
                }
              },
            }
          );
        } else {
          this.batchUpdateFreightLogistics();
        }
      }
    },
    // 批量修改箱子的发送方式
    batchUpdateFreightLogistics() {
      let datas = {
        logistics_id: this.logistics_id,
        freight_id_set: this.boxIds,
      };
      let data = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.batchUpdateFreightLogistics(datas).then((res) => {
        this.$message.success(res.msg);
        this.visible = false;
        this.logistics_id = "";

        // 先刷新箱子
        this.$api.porderApi.freightList(data).then((res) => {
          this.$store.commit("setFreightList", res.data);
          // 查看有没有偏远费，超大件费用，
          this.$api.porderApi.porderAmountCurrent(data).then((res) => {
            let list = [];
            res.data.logisticsFeePart.forEach((item) => {
              item.extra_money.forEach((items) => {
                if (items.extra_fee_rmb > 0) {
                  items.logistics_id = item.logistics_id;
                  items.freight_id = this.getLogisticsFreight_id(
                    item.logistics_id
                  );
                  list.push(items);
                }
              });
            });
            // 有偏远费，超大件费用 新增其他费用
            this.detail.other_price_list = [];
            list.forEach((item) => {
              this.detail.other_price_list.push({
                porder_sn: this.porder_sn,
                logistics_id: item.logistics_id,
                type: 1,
                desc: item.extra_fee_name,
                fee: item.extra_fee_rmb,
                freight_id: item.freight_id,
              });
            });
            let porderOtherFeeData = {
              porder_sn: this.porder_sn,
              list:
                this.detail.other_price_list != false
                  ? this.detail.other_price_list
                  : "",
            };
            this.$api.porderApi
              .setPorderOtherFee(porderOtherFeeData)
              .then((res) => {
                this.$message.success(res.msg);
                this.$store.dispatch("porderDetail", data);
                this.dialogVisible = false
              });

            // 刷新配送单跟箱子详情
            this.$store.commit("setBoxIds", []);
          });
        });

        // 检查偏远费
        this.checkSpecialAddress();
      });
    },
    //查询物流方式第一箱ID
    getLogisticsFreight_id(logistics_id) {
      let freight_id = "";
      this.boxList.forEach((item) => {
        item.group.forEach((group) => {
          if (group.logistics_id == logistics_id) {
            freight_id = group.list[0].id;
          }
        });
      });
      return freight_id;
    },
    // tw是否大于箱规三边和超过160cm时
    isMax160() {
      let flag = false;
      // 定义需要检查的物流ID常量
      const SIZE_CHECK_LOGISTICS_IDS = [12, 18, 2, 20, 15, 23, 24, 25];
      for (let i = 0; i < this.boxList.length; i++) {
        this.boxList[i].group.forEach((item) => {
          if (SIZE_CHECK_LOGISTICS_IDS.includes(this.logistics_id)) {
            let max160 = 0;
            item.list.forEach((items) => {
              if (items.checked) {
                max160 = items.height + items.width + items.length;
                if (max160 > 160) {
                  flag = true;
                }
              }
            });
          }
        });
      }
      return flag;
    },
    //EMS单箱 ，实际重量超过30KG 的
    isMax30() {
      let flag = false;
      for (let i = 0; i < this.boxList.length; i++) {
        this.boxList[i].group.forEach((item) => {
          if (this.logistics_id == 1) {
            item.list.forEach((items) => {
              if (items.checked) {
                if (items.weight > 30) {
                  flag = true;
                }
              }
            });
          }
        });
      }
      return flag;
    },
    // 检查偏远费
    checkSpecialAddress() {
      let datas = {
        porder_sn: this.porder_sn,
      };
      this.$api.porderApi.checkSpecialAddress(datas).then((res) => {
        if (res.data.is_special) {
          this.$alert(
            `<p style="color:red;font-size:20px">当前地址邮编匹配属于(${res.data.special_address})，有可能会产生偏远费用，报价时请注意该物流对于该地区是否有偏远费用！！！
          下面物流部分地区包含部分偏远收费：<br/> 
          1.KS-JP （沖縄・北海道・鹿児島）<br/> 
          2.电子特殊便（沖縄・北海道・鹿児島）<br/> 
          3.DQ船便  （遠隔地費用あり）<br/> 
          4.TW船便 （遠隔地費用あり）<br/> 
          5.OCS（冲绳）
            </p>
            `,
            "提示",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              callback: (action) => {
                let checkSpecialAddress = localStorage.getItem(
                  "checkSpecialAddress"
                )
                  ? JSON.parse(localStorage.getItem("checkSpecialAddress"))
                  : [];
                checkSpecialAddress.push(this.porder_sn);
                localStorage.setItem(
                  "checkSpecialAddress",
                  JSON.stringify(checkSpecialAddress)
                );
              },
            }
          );
        }
      });
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.predictLogisticsPrice();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  h6 {
    background-color: #f6f6f6;
    padding: 10px;
    margin-bottom: 24px;
    border-radius: 5px;

    span {
      font-size: 16px;
      margin-right: 20px;
    }
  }

  .template {
    width: 100%;
    text-align: left;
  }
}

/deep/.el-table__header-wrapper th.redText {

  background-color: #B4272D !important;
  color: #fff !important;
}

/deep/.el-table .cell {

  min-height: 50px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: none !important;

}
</style>